<!-- Banda navy del chasis de la liga: la primera tarjeta de cada pantalla monta 130 px sobre ella. -->
<header class="header-navigation" [style]="{background: background, color: color}">
  <ng-container *ngIf="backRoute !== '';else elseBackRoute">
    <button type="button" class="icon-action" aria-label="Regresar" [routerLink]="backRoute" (click)="onClick.emit()">
      <fa-icon [icon]="icons.back" aria-hidden="true"></fa-icon>
    </button>
  </ng-container>
  <ng-template #elseBackRoute>
    <span class="icon-espacio" aria-hidden="true"></span>
  </ng-template>
  <h1 class="header-navigation__titulo">{{title}}</h1>
  <ng-container *ngIf="closeRoute !== ''; else elseIcon">
    <button type="button" class="icon-action" aria-label="Cerrar" [routerLink]="closeRoute">
      <fa-icon [icon]="rightIcon" aria-hidden="true"></fa-icon>
    </button>
  </ng-container>
  <ng-template #elseIcon>
    <span class="icon-espacio" aria-hidden="true"></span>
  </ng-template>
</header>
